module.exports = "/images/story-banner-Raptor-Training-2.jpg?2176aa3dd1bb3f1e3ddbb8c0a5b4aae0";